var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Box, CardContent, CardMedia, Stack, Typography, useTheme } from "@mui/material";
import { CardWithShadow, ShareArea } from "../components";
import useIosContext from "@nitra/nkmb-card-components/contexts/IosContextProvider";
import { getLocalizedString } from "@nitra/nkmb-card-components/utils";
import { useTranslation } from "react-i18next";
export var SingleShopCard = function (props) {
    var _a;
    var title = props.title, price = props.price, oldPrice = props.oldPrice, shopUrl = props.shopUrl, imageUrl = props.imageUrl;
    var _b = useState(1), scale = _b[0], setScale = _b[1];
    var isIos = useIosContext().isIos;
    var theme = useTheme();
    var i18n = useTranslation().i18n;
    var currentLang = i18n.language;
    return (_jsxs(CardWithShadow, __assign({ to: shopUrl, onMouseEnter: function () { return setScale(1.08); }, onMouseLeave: function () { return setScale(1); }, sx: {
            position: "relative",
            display: "flex",
            flexDirection: "column"
        }, fixedWidth: 288 }, { children: [_jsx(CardMedia, { image: imageUrl, sx: {
                    mt: 3,
                    height: "196px",
                    backgroundSize: "contain",
                    transform: "scale(".concat(scale, ")"),
                    transition: "transform 1.5s",
                } }), _jsxs(CardContent, __assign({ sx: {
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                } }, { children: [_jsxs(Stack, __assign({ direction: "column", justifyContent: "space-between", alignItems: "center", textAlign: "center", sx: {
                            flexGrow: 1,
                            // color: "#181818"
                        } }, { children: [_jsx(Typography, __assign({ variant: "podnaslovS" }, { children: getLocalizedString(title, currentLang) })), _jsxs(Stack, { children: [_jsx(Typography, __assign({ variant: "h4", sx: (_a = {},
                                            _a[theme.breakpoints.down("sm")] = isIos && {
                                                '@media (-webkit-min-device-pixel-ratio: 2)': {
                                                    fontWeight: 500, // Adjust font weight for iPhones
                                                },
                                            },
                                            _a) }, { children: price })), oldPrice &&
                                        _jsx(Typography, __assign({ sx: { textDecorationLine: "line-through" } }, { children: oldPrice }))] })] })), _jsx(Box, __assign({ sx: {
                            p: 2,
                            position: "absolute",
                            bottom: 0,
                            right: 0,
                        } }, { children: _jsx(ShareArea, { shareUrl: shopUrl, brightText: false }) }))] }))] })));
};
